// extracted by mini-css-extract-plugin
export default {"container":"PageHolder_container__z9VWR","title":"PageHolder_title__qbUob","text":"PageHolder_text__LkRlB","img":"PageHolder_img__k0vgn"};